<template>
  <div>
    <div>
      <img src="https://gcjy-images-cdn.ahsjxjy.com/doujuanApi/prod/DouJuan/images/2025/04/09/images_1744171318289.png" alt="铜仁学院省级专业技术人员继续教育培训平台" />
    </div>

    <div style="display: flex; justify-content: center; width: 1400px">
      <a
        class="btnShop"
        rel="nofollow"
        target="_blank"
        href="https://ahgcjykjyxgs.qiyukf.com/client?k=dafbd24366a8c31bb28f2737a1b7698e&wp=1&robotShuntSwitch=0&templateId=8136501&language=zh-cn&t=铜仁学院省级专业技术人员继续教育培训平台"
      >
        <div>我也要冠成合作</div>
        <div style="margin-left: 4px"><img src="../../assets/indexImg/jt.png" alt="铜仁学院省级专业技术人员继续教育培训平台" /></div>
      </a>
    </div>
  </div>
</template>
<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
export default {
  // import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    // 这里存放数据
    return {};
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {},
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, // 生命周期 - 创建之前
  beforeMount() {} // 生命周期 - 挂载之前
};
</script>
<style lang="less" scoped>
/* //@import url(); 引入公共css类 */
.btnShop {
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  margin-top: 52px;
  text-align: center;
  color: #4076f6;
  font-size: 16px;
  font-weight: 500;
  width: 200px;
  height: 48px;
  border-radius: 4px 4px 4px 4px;
  border: 1px solid;
  border-image: linear-gradient(97deg, rgba(149, 181, 255, 1), rgba(64, 147, 246, 1)) 1 1;
}
</style>
